<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :custom-label="labelSelect"
    :options="options"
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="false"
    :label="$t('Nome')"
    track-by="value"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <div>
        <flag :iso="option.iso2" :squared="false" class="mr-1" v-if="showFlag" />
        <span>{{ option.text }}</span>
      </div>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div>
        <flag :iso="option.iso2" :squared="false" class="mr-1" v-if="showFlag" />
        <span>{{ option.text }}</span>
      </div>
    </template>
  </multiselect>
</template>
<script>
export default {
  props: ['nameField', 'isDisabled', 'lowercase', 'showFlag'],
  data() {
    return {
      selected: this.isLowercase ? 'pt-br' : 'pt-BR',
      options: [
        { iso2: 'BR', value: this.isLowercase ? 'pt-br' : 'pt-BR', text: this.$i18n.t('Português') },
        { iso2: 'US', value: 'en', text: this.$i18n.t('Inglês') },
        { iso2: 'PE', value: 'es', text: this.$i18n.t('Espanhol') }
      ]
    };
  },
  computed: {
    isLowercase() {
      return this.lowercase === true;
    }
  },
  watch: {
    nameField(value) {
      this.setValue(value);
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'idioma', null);
        return;
      }
      this.$emit('selectChange', 'idioma', e.value);

      this.$emit('focus');
    },
    labelSelect({ text }) {
      return `${text}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => String(option.value) === String(value));
      } else {
        this.selected = this.options.find((option) => option.value === null);
      }
      this.$emit('input', this.selected);
    }
  },
  created() {
    this.setValue(this.nameField);
  }
};
</script>

<style lang="scss" scoped></style>
